import { BASE_APP_PAth } from "../api/launchpad-api";

/** App-internal legal page; must not be forced into the quote funnel on load. */
export const INSURANCE_RELATED_PARTNERS_PATH = `${BASE_APP_PAth}/insurance-related-partners`;

/**
 * When true, App startup navigation must leave the current path alone
 * (e.g. insurance-related-partners opened from Legal Notices in a new tab).
 */
export function shouldBypassQuoteFunnelRedirect(pathname: string | null | undefined): boolean {
    if (!pathname) {
        return false;
    }
    return pathname.toLowerCase().includes("insurance-related-partners");
}
